import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  ACTIVITY_ID,
  ACTIVITY_NAME,
  ANNOUNCEMENT_ENTRY_ID,
  ANNOUNCEMENT_FROM,
  ANNOUNCEMENT_HEADING,
  ANNOUNCEMENT_STATUS,
  ANNOUNCEMENT_TO,
  CREATED_ON,
  CALENDAR_DISPLAY_FOR,
  CALENDAR_DISPLAY_ID,
  CALENDAR_FROM,
  CALENDAR_TASK_DATE,
  CALENDAR_TO,
  DAYS_ELAPSED,
  DEPARTMENT,
  DESIGNATION,
  DOB,
  EMPLOYEE_ID,
  EMP_STATUS,
  COMPANY_ENTITY_DISPLAY_ID,
  ID,
  JOINING_DATE,
  LOCATION,
  NAME,
  REQUEST_INITIATED_ON,
  RESPONSE_DUE_BY,
  TASK_CURRENT_STATUS,
  ASSIGNED_TO_DISPLAY_ID,
  EMP_STATUS_SELECT
} from 'src/app/constants/ui.columns'
import { load_employee_summary_action } from 'src/app/store/action/employee.action'
import {
  SummaryDataTableComponent,
  SummaryDataTableData,
  SummaryDataTableOptions
} from '../../common/summary-data-table/summary-data-table.component'
import { getAllEmployeeDetails } from 'src/app/store/selector/employee.selector'
import { AppState } from 'src/app/store/state/app.state'
import { Store } from '@ngrx/store'
import { ActivatedRoute, Router } from '@angular/router'
import { activitySummaryDetailsSelector } from 'src/app/store/selector/activity.selector'
import { LOAD_ACTIVITY_SUMMARY_DETAILS } from 'src/app/store/action/activity.action'
import { load_calendar_summary_action } from 'src/app/store/action/calendar.action'
import { getAllCalendarSummary } from 'src/app/store/selector/calendar.selector'
import { getAllAnnouncementSummary } from 'src/app/store/selector/announcement.selector'
import { load_announcement_summary_action } from 'src/app/store/action/announcement.action'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { DocumentService } from 'src/app/services/common/document.service'
import { CommonService, removeEmptyKeys, selectEmployeeStatus } from 'src/app/services/common/common.service'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { ActivityValidator } from '../../activity/create-activity/create-activity.component'
import { ActivityService } from 'src/app/services/activity/activity.service'
import { QueryValidator } from '../../query/create-query/create-query.component'
import { QueryService } from 'src/app/services/query/query.service'
import { CalendarService } from 'src/app/services/calendar/calendar.service'
import { CalendarEventValidator } from '../../calendar-info/create-calendar/create-calendar.component'
import { EmployeeService } from 'src/app/services/employee/employee.service'
import { WebService } from 'src/app/services/api/web.service'
import { InsertEmployeeValidator } from '../../import/validators/insert-employee.validator'
import { getEnabledModules } from 'src/app/store/selector/company-settings.selector'

@Component({
  selector: 'app-repository-summary',
  templateUrl: './data-repository-summary.component.html',
  styleUrls: ['./data-repository-summary.component.scss']
})
export class DataRepositorySummaryComponent implements OnInit {
  dataReportList$: Observable<any>
  summaryOptions: SummaryDataTableOptions
  showImport = false
  summaryData: SummaryDataTableData<any>
  queryParamValues = {
    pageNo: 0,
    pageLimit: SummaryDataTableComponent.defaultLimitDropdownValue,
    sortBy: 'firstName',
    sortOrder: 'ASC',
    mapReferenceDocuments: 'false'
  }
  searchRequestBody = {}
  headerNames = []
  reportId: string
  id: string

  viewOptions$: Observable<any[]>
  importValidator: any
  pageTitle = 'Data Repository'
  dashboardPageLink = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${GlobalConstants.ROUTING.QUICK_SELECT}`

  constructor(
    private route: ActivatedRoute,
    private appState: Store<AppState>,
    private documentService: DocumentService,
    private cs: CommonService,
    private router: Router,
    private actvityService: ActivityService,
    private queryService: QueryService,
    private calendarService: CalendarService,
    private employeeService: EmployeeService,
    private webService: WebService
  ) {
    this.summaryOptions = {
      downloadable: true,
      additionalButtons: false,
      contentSelectable: true,
      contentSelector: false,
      filterable: true,
      formattedContent: false,
      pageable: true,
      sortable: true,
      quickFilters: true
    }
  }

  ngOnInit(): void {
    this.viewOptions$ = this.appState.select(getEnabledModules).pipe(
      map(enabledModules =>
        GlobalConstants.DATA_REPO_QUICK_SELECT_OPTIONS.filter(
          opt => !(opt as any).module || enabledModules.includes((opt as any).module)
        )
      )
    )
    this.route.params.subscribe(params => {
      this.selectedRepository(params['id'])
    })
    this.summaryData = {
      content$: this.dataReportList$,
      headers: this.headerNames,
      additionalButtons: [],
      currentSearchParams: this.queryParamValues,
      sortCallback: this.sortCallback,
      checkBoxSelectionIds: [],
      searchCallback: this.searchCallback,
      selectPageCallback: this.selectPageCallback,
      onDropdownLimitChange: this.onDropdownLimitChange,
      downloadDocumentCallback: this.downloadDocumentCallback
    }
  }

  selectedRepository(id: any) {
    this.reportId = id
    this.id = id
    switch (id) {
      case '1': {
        this.employeeDocuments()
        this.importValidator = new InsertEmployeeValidator(this.employeeService, null, this.webService, false)
        break
      }
      case '2': {
        this.calenderEvents()
        this.importValidator = new CalendarEventValidator(this.calendarService)
        break
      }
      case '3': {
        this.employeeQueries()
        this.importValidator = new QueryValidator(this.queryService)
        break
      }
      case '4': {
        this.activities()
        this.importValidator = new ActivityValidator(this.actvityService)
        break
      }
    }
  }

  monthlyECRCumChallan() {
    this.queryParamValues.sortBy = 'createdDatetime'
    this.searchRequestBody = {
      name: 'EPF_MONTHLY_CHALLAN',
      category: 'EPF'
    }
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.headerNames = [
      COMPANY_ENTITY_DISPLAY_ID,
      ACTIVITY_ID,
      ACTIVITY_NAME,
      EMPLOYEE_ID,
      REQUEST_INITIATED_ON,
      DAYS_ELAPSED,
      RESPONSE_DUE_BY,
      TASK_CURRENT_STATUS
    ]
    this.dispatchLoadActivitySummaryDetailsAction(options)
  }

  activities() {
    this.queryParamValues.sortBy = 'createdDatetime'
    this.headerNames = [
      COMPANY_ENTITY_DISPLAY_ID,
      ACTIVITY_ID,
      ACTIVITY_NAME,
      EMPLOYEE_ID,
      REQUEST_INITIATED_ON,
      ASSIGNED_TO_DISPLAY_ID,
      RESPONSE_DUE_BY,
      TASK_CURRENT_STATUS
    ]
    this.searchRequestBody = {
      category: 'EPF'
    }
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.dispatchLoadActivitySummaryDetailsAction(options)
  }

  communications() {
    this.queryParamValues.sortBy = 'heading'
    this.headerNames = [
      ANNOUNCEMENT_ENTRY_ID,
      ANNOUNCEMENT_HEADING,
      ANNOUNCEMENT_FROM,
      ANNOUNCEMENT_TO,
      ANNOUNCEMENT_STATUS
    ]
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.dispatchLoadAnnouncementSummaryAction(options)
  }

  circularsNotifications() {
    this.communications()
  }

  calenderEvents() {
    this.queryParamValues.sortBy = 'displayId'
    this.headerNames = [
      CALENDAR_DISPLAY_ID,
      CREATED_ON,
      CALENDAR_FROM,
      CALENDAR_TO,
      CALENDAR_TASK_DATE,
      CALENDAR_DISPLAY_FOR
    ]
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.dispatchLoadCalendarSummayAction(options)
  }

  adhocECRCumChallan() {
    this.queryParamValues.sortBy = 'createdDatetime'
    this.searchRequestBody = {
      name: 'EPF_AD_HOC_CHALLAN',
      category: 'EPF'
    }
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.headerNames = [
      COMPANY_ENTITY_DISPLAY_ID,
      ACTIVITY_ID,
      ACTIVITY_NAME,
      EMPLOYEE_ID,
      REQUEST_INITIATED_ON,
      DAYS_ELAPSED,
      RESPONSE_DUE_BY,
      TASK_CURRENT_STATUS
    ]
    this.dispatchLoadActivitySummaryDetailsAction(options)
  }

  employeeDocuments() {
    this.searchRequestBody = {
      firstName: '',
      dob: null,
      doj: null,
      designation: '',
      location: '',
      departmentName: '',
      status: ''
    }
    this.headerNames = [
      COMPANY_ENTITY_DISPLAY_ID,
      ID,
      NAME,
      DOB,
      JOINING_DATE,
      DESIGNATION,
      DEPARTMENT,
      LOCATION,
      EMP_STATUS_SELECT
    ]
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.dispatchLoadEmployeeListAction(options)
  }

  employeeQueries() {
    this.searchRequestBody = {
      firstName: '',
      dob: null,
      doj: null,
      designation: '',
      location: '',
      departmentName: '',
      status: ''
    }
    this.headerNames = [ID, NAME, DOB, JOINING_DATE, DESIGNATION, DEPARTMENT, LOCATION, EMP_STATUS]
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.dispatchLoadEmployeeListAction(options)
  }

  onViewForChange = event => {
    this.queryParamValues.pageLimit = event.target.value
    this.loadSummaryData()
  }

  sortCallback = (columnCode, order) => {
    this.queryParamValues.sortBy = columnCode
    this.queryParamValues.sortOrder = order
    this.loadSummaryData()
  }

  buildQueryParams = (buildForDownload = false): { key: string; value: string }[] => {
    return [
      {
        key: 'pageNo',
        value: this.queryParamValues.pageNo.toString()
      },
      {
        key: 'limit',
        value: buildForDownload
          ? GlobalConstants.FILE_DOWNLOAD_CONFIG.ROW_LIMIT.toString()
          : this.queryParamValues.pageLimit.toString()
      },
      {
        key: 'sortBy',
        value: this.queryParamValues.sortBy
      },
      {
        key: 'sortOrder',
        value: this.queryParamValues.sortOrder
      },
      {
        key: 'mapReferenceDocuments',
        value: this.queryParamValues.mapReferenceDocuments
      }
    ]
  }

  private loadSummaryData() {
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.appState.dispatch(load_employee_summary_action(options))
  }

  searchCallback = searchParams => {
    if (this.id == '1') {
      if (searchParams.status) {
        searchParams.status = selectEmployeeStatus(searchParams.status)
      }
    }
    this.searchRequestBody = { ...searchParams, ...this.getRequiredSearchFilters(this.id) }
    const options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: removeEmptyKeys(this.searchRequestBody)
    }
    this.searchRepository(this.id, options)
  }

  selectPageCallback = pageNum => {
    this.queryParamValues.pageNo = pageNum
    this.ngOnInit()
  }

  private onDropdownLimitChange = (limit: number) => {
    this.queryParamValues.pageLimit = limit
    this.loadSummaryData()
  }

  downloadDocumentCallback = documentType => {
    const checkBoxSelectionIds = this.summaryData.checkBoxSelectionIds
    if (checkBoxSelectionIds.length > 0) {
      this.searchRequestBody = {
        ids: checkBoxSelectionIds
      }
    }
    const options = {
      queryParams: this.buildQueryParams(),
      requestBody: this.searchRequestBody
    }
    let endPoint: string
    switch (this.reportId) {
      case '1': {
        options.queryParams = this.buildQueryParams(true)
        endPoint = `${ServiceUrlConstants.API_EMPLOYEE_SUMMARY_LIST_EXPORT + documentType}`
        break
      }
      case '2': {
        options.queryParams = this.buildQueryParams(true)
        endPoint = `${ServiceUrlConstants.API_CALENDAR_SUMMARY_LIST_EXPORT + documentType}`
        break
      }
      case '3': {
        endPoint = `${ServiceUrlConstants.API_ACTIVITY_SUMMARY_LIST + ServiceUrlConstants.API_EXPORT + documentType}`
        break
      }
      case '4': {
        options.queryParams = this.buildQueryParams(true)
        endPoint = `${ServiceUrlConstants.API_ACTIVITY_SUMMARY_LIST + ServiceUrlConstants.API_EXPORT + documentType}`
        break
      }
      case '5': {
        endPoint = `${ServiceUrlConstants.API_ANNOUNCEMENT_SUMMARY_LIST_EXPORT + documentType}`
        break
      }
      case '6': {
        endPoint = `${ServiceUrlConstants.API_ANNOUNCEMENT_SUMMARY_LIST_EXPORT + documentType}`
        break
      }
      case '7': {
        endPoint = `${ServiceUrlConstants.API_ACTIVITY_SUMMARY_LIST + ServiceUrlConstants.API_EXPORT + documentType}`
        break
      }
    }
    this.documentService.downloadDocument(endPoint, options)
  }

  private dispatchLoadActivitySummaryDetailsAction(options: {
    queryParams: { key: string; value: string }[]
    searchRequestBody: {}
  }) {
    this.appState.dispatch(LOAD_ACTIVITY_SUMMARY_DETAILS(options))
    this.dataReportList$ = this.appState.select(activitySummaryDetailsSelector())
  }

  private dispatchLoadEmployeeListAction(options: {
    queryParams: { key: string; value: string }[]
    searchRequestBody: {}
  }) {
    this.appState.dispatch(load_employee_summary_action(options))
    this.dataReportList$ = this.appState.select(getAllEmployeeDetails())
  }

  private dispatchLoadCalendarSummayAction(options: {
    queryParams: { key: string; value: string }[]
    searchRequestBody: {}
  }) {
    this.appState.dispatch(load_calendar_summary_action(options))
    this.dataReportList$ = this.appState.select(getAllCalendarSummary())
  }

  private dispatchLoadAnnouncementSummaryAction(options: {
    queryParams: { key: string; value: string }[]
    searchRequestBody: {}
  }) {
    this.appState.dispatch(load_announcement_summary_action(options))
    this.dataReportList$ = this.appState.select(getAllAnnouncementSummary())
  }

  searchRepository(id: any, options: { queryParams: { key: string; value: string }[]; searchRequestBody: any }) {
    this.reportId = id
    switch (id) {
      case '1':
        this.dispatchLoadEmployeeListAction(options)
        break
      case '2':
        this.dispatchLoadCalendarSummayAction(options)
        break
      case '4':
        if (options?.searchRequestBody?.statusList) {
          options.searchRequestBody.statusList = [options.searchRequestBody.statusList]
        }
        this.dispatchLoadActivitySummaryDetailsAction(options)
        break
    }
  }

  getRequiredSearchFilters(id: any) {
    let searchFilters = {}
    switch (id) {
      case '2': {
        searchFilters = {
          name: 'EPF_MONTHLY_CHALLAN',
          category: 'EPF'
        }
        break
      }
      case '3': {
        searchFilters = {
          name: 'EPF_AD_HOC_CHALLAN',
          category: 'EPF'
        }
        break
      }
      case '7': {
        searchFilters = {
          category: 'EPF'
        }
        break
      }
    }
    return searchFilters
  }

  onViewSelect(id: string) {
    const summaryPage = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${id}/${GlobalConstants.ROUTING.SUMMARY}`
    this.router.navigateByUrl(GlobalConstants.ROUTING.DATA_REPOSITORY, { skipLocationChange: true }).then(() => {
      this.cs.routeTo(summaryPage)
    })
  }
}
